export default "__VITE_ASSET__C0f$EN4X__"